import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

//状态
const state = {
    userinfo: JSON.parse(localStorage.getItem('userinfo')),
    status: '',
    grxinxi: {},
    id: '',
    title: '',
    pdfUrl: '',
    pptUrl: JSON.parse(sessionStorage.getItem('pptUrl')),
    zpdataAll: JSON.parse(sessionStorage.getItem('zpdataAll'))
}

//mutations 主要操作state
const mutations = {
    //保存用户数据
    logduser(state, userinfo) {
        //先把数据存到本地
        localStorage.setItem('userinfo', JSON.stringify(userinfo));
        // let userinfos = JSON.parse(localStorage.getItem('userinfo'));
        state.userinfo = userinfo;

    },
    // 信息审核状态
    statusloding(state, status) {
        state.status = status;

    },
    // 教师用户信息 认证信息状态
    grxinxi(state, grxinxi) {

        localStorage.setItem('grxinxi', JSON.stringify(grxinxi));
        state.grxinxi = grxinxi;

    },
    //作品ID
    zuopbtnId(state, id) {
        // let x = document.cookie = "id=" + id;
        sessionStorage.setItem('id', id);
        state.id = id;

    },
    //搜索的标题
    searchbtn(state, title) {
        state.title = title;
    },
    //PDFurl
    pdfresdata(state, pdfUrl) {
        state.pdfUrl = pdfUrl;

    },
    //pptimgs
    pptimgsUrl(state, pptUrl) {
        sessionStorage.setItem('pptUrl', JSON.stringify(pptUrl))
        state.pptUrl = pptUrl;

    },
    //作品详情存储
    zpdataall(state, zpdataAll) {
        sessionStorage.setItem('zpdataAll', JSON.stringify(zpdataAll))
        state.zpdataAll = zpdataAll;
        // console.log(state.zpdataAll, '这是作品信息')
    }
}

export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store/store.js